<template>
  <q-card
    class="storyCardForm"
    style="width: 750px; max-width: 90vw; height: 550px; max-height: 90vh"
  >
    <q-card-section
      class="q-pa-md text-white storyCardHeader shadow-6 bg-accent"
    >
      <h3 class="q-my-none">
        {{ formData.label }} Plan Settings
        <q-btn
          flat
          round
          icon="mdi-close"
          class="float-right"
          @click="close"
          style="position: absolute; top: 10px; right: 10px"
        ></q-btn>
      </h3>
    </q-card-section>
    <q-card-section class="q-pa-none" style="height: calc(100% - 62px)">
      <div class="row full-height">
        <div class="col-12 q-pa-sm full-height">
          <q-scroll-area
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            style="height: 100%"
          >
            <div class="row q-pa-md">
              <div class="col-12">
                <h4 class="q-my-none">General</h4>
              </div>
              <div class="col-12 q-py-xs">
                <q-btn
                  no-caps
                  label="Reset Questionnaire"
                  color="negative"
                  flat
                  :loading="resettingQuestionnaire"
                  @click="resetQuestionnaire"
                ></q-btn>
              </div>
            </div>
          </q-scroll-area>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getCSSVars } from "@/functions/cssVars";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUserData: "auth/currentUserData",
        selectedOutcome: "businessOutcomePlans/selectedOutcome",
        data: "businessOutcomePlans/current",
        dataLoading: "businessOutcomePlans/currentLoading",
      }),
      cssVars() {
        let outcome = this.selectedOutcome;
        return getCSSVars(outcome);
      },
    },

    data: () => ({
      formData: {},
      newImage: null,

      saving: false,
      resettingQuestionnaire: false,
    }),
    watch: {
      data: function () {
        this.init();
      },
      selectedOutcome: function () {
        this.initSelectedOutcome();
      },
      $route: {
        handler() {
          this.handleRoute();
        },
        props: true,
      },
      newImage() {
        this.newImageUploaded();
      },
    },
    async mounted() {
      this.loadData();
    },
    methods: {
      getCSSVars: getCSSVars,

      init() {
        if (this.data != null && this.data.id == this.$route.params.plan_id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};

          if (this.selectedOutcome) {
            this.formData.outcomes.push(this.selectedOutcome);
          }
        }
      },

      loadData() {
        this.$store.dispatch("businessOutcomePlans/loadByID", {
          id: this.$route.params.plan_id,
        });
      },

      async save() {
        this.saving = true;

        try {
          let response = await this.$store.dispatch(
            "businessOutcomePlans/save",
            this.formData
          );

          this.$q.notify({
            position: "top-right",
            type: response.Result == "Success" ? "positive" : "negative",
            message: response.Response.Message,
          });

          this.$emit("reloadData");
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an error, Please try again later",
          });
        }
        this.saving = false;
      },

      handleRoute() {},

      close() {
        this.$router.push(`${this.$route.path.split(`/settings`)[0]}`);
      },

      async resetQuestionnaire() {
        this.$swal({
          title: "Warning",
          text: "You are about to Reset the questionnaire for this plan. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            this.resettingQuestionnaire = true;

            try {
              let response = await this.$store.dispatch(
                "businessOutcomePlans/resetQuestionnaire",
                {
                  id: this.formData.outcome_id,
                }
              );

              this.$q.notify({
                position: "top-right",
                type: response.Result == "Success" ? "positive" : "negative",
                message: response.Response.Message,
              });
            } catch (error) {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an error, Please try again later",
              });
            }
            this.resettingQuestionnaire = false;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .storyCardForm {
    h4 {
      font-size: 1rem;
      font-weight: 600;
      color: $accent;
    }

    .outcomeTag {
      font-weight: 600;
      background: #ecfbff;
    }

    .storyCardHeader {
      h3 {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 30px;
      }
    }
  }
</style>
